/**
 * @generated SignedSource<<47d0beaed867fb6226989760e5bcf9f1>>
 * @relayHash 638bac7b9e0c36f63a93dacf91f49d73
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 47c62643de44eeb465b6457f40828a8c74b43006640566b62fb4b9d776f1b9f3

import type { ConcreteRequest } from 'relay-runtime';
export type JsmChannelsResolutionPlanAssigneeType = "HUMAN" | "TASK_AGENT" | "%future added value";
export type JsmChannelsResolutionPlanStatus = "APPROVED" | "PAUSED" | "PENDING" | "REJECTED" | "%future added value";
export type JsmChannelsResolutionPlanStepStatus = "CANCELLED" | "COMPLETED" | "FAILED" | "IN_PROGRESS" | "PENDING" | "WAITING" | "%future added value";
export type ResolutionPlanSSRResourceQuery$variables = {
  jiraProjectAri: string;
  ticketId: string;
};
export type ResolutionPlanSSRResourceQuery$data = {
  readonly jsmChannels_getServiceAgentResolutionStateByTicketId: {
    readonly __typename: "JsmChannelsTicketServiceAgentResolutionState";
    readonly conversationId: string | null;
    readonly isLoading: boolean;
    readonly message: string | null;
    readonly plan: {
      readonly contentSources: ReadonlyArray<{
        readonly ari: string | null;
        readonly confidenceScore: number | null;
        readonly product: string | null;
        readonly title: string | null;
        readonly type: string | null;
        readonly url: string | null;
      } | null> | null;
      readonly customPlanNodeAttributes: ReadonlyArray<{
        readonly key: string;
        readonly value: string;
      }> | null;
      readonly planId: string | null;
      readonly runbooks: ReadonlyArray<{
        readonly confidenceScore: number | null;
        readonly title: string;
        readonly url: string;
      } | null> | null;
      readonly status: JsmChannelsResolutionPlanStatus | null;
      readonly steps: ReadonlyArray<{
        readonly assigneeType: JsmChannelsResolutionPlanAssigneeType | null;
        readonly description: string | null;
        readonly status: JsmChannelsResolutionPlanStepStatus | null;
        readonly title: string;
      } | null> | null;
    } | null;
  } | {
    readonly __typename: "QueryError";
    readonly message: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type ResolutionPlanSSRResourceQuery = {
  response: ResolutionPlanSSRResourceQuery$data;
  variables: ResolutionPlanSSRResourceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jiraProjectAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ticketId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "message"
},
v2 = {
  "kind": "ScalarField",
  "name": "status"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "confidenceScore"
},
v5 = {
  "kind": "ScalarField",
  "name": "url"
},
v6 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "jiraProjectAri",
        "variableName": "jiraProjectAri"
      },
      {
        "kind": "Variable",
        "name": "ticketId",
        "variableName": "ticketId"
      }
    ],
    "kind": "LinkedField",
    "name": "jsmChannels_getServiceAgentResolutionStateByTicketId",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "conversationId"
          },
          {
            "kind": "ScalarField",
            "name": "isLoading"
          },
          (v1/*: any*/),
          {
            "concreteType": "JsmChannelsServiceAgentResolutionPlan",
            "kind": "LinkedField",
            "name": "plan",
            "plural": false,
            "selections": [
              {
                "concreteType": "JsmChannelsCustomPlanNodeAttribute",
                "kind": "LinkedField",
                "name": "customPlanNodeAttributes",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "planId"
              },
              (v2/*: any*/),
              {
                "concreteType": "JsmChannelsServiceAgentResolutionPlanStep",
                "kind": "LinkedField",
                "name": "steps",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "assigneeType"
                  }
                ]
              },
              {
                "concreteType": "JsmChannelsServiceAgentResolutionRunbook",
                "kind": "LinkedField",
                "name": "runbooks",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v5/*: any*/)
                ]
              },
              {
                "concreteType": "JsmChannelsServiceAgentResolutionContentSource",
                "kind": "LinkedField",
                "name": "contentSources",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "ari"
                  },
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "product"
                  }
                ]
              }
            ]
          }
        ],
        "type": "JsmChannelsTicketServiceAgentResolutionState"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v1/*: any*/)
        ],
        "type": "QueryError"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ResolutionPlanSSRResourceQuery",
    "selections": (v6/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResolutionPlanSSRResourceQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "id": "47c62643de44eeb465b6457f40828a8c74b43006640566b62fb4b9d776f1b9f3",
    "metadata": {},
    "name": "ResolutionPlanSSRResourceQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3fb9f09841646bb9e8481234f2983e57";

export default node;
